import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ShareIcon from "@mui/icons-material/Share";
import { toast } from "react-toastify";

import { MenuItemType } from "@/pages/scenario-builder/types";

import { ContextMenuOption } from "./types";

export const createShareLinkOption = (
  url: string,
  toastMessage = "URL copied to clipboard"
): ContextMenuOption => ({
  label: MenuItemType.ShareLink,
  icon: ShareIcon,
  onClick: async () => {
    const fullUrl = `${window.location.origin}${url}`;
    try {
      await navigator.clipboard.writeText(fullUrl);
      toast.info(toastMessage);
    } catch {
      toast.error("Failed to copy URL to clipboard");
    }
  },
});

export const createDeleteOption = (onDelete: () => void): ContextMenuOption => ({
  label: MenuItemType.Delete,
  icon: DeleteOutlineOutlinedIcon,
  onClick: onDelete,
  variant: "danger",
});
